import { render, staticRenderFns } from "./component-a8fee867.vue?vue&type=template&id=252a926c&scoped=true&"
import script from "./component-a8fee867.vue?vue&type=script&lang=js&"
export * from "./component-a8fee867.vue?vue&type=script&lang=js&"
import style0 from "./component-a8fee867.vue?vue&type=style&index=0&id=252a926c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a926c",
  null
  
)

export default component.exports